/* RESPONSIBLE TEAM: team-automation-foundations */
export default class StaticEdge {
  get isStatic() {
    return true;
  }
}
